<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                placeholder="HTML ID Attribute"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'html-id-override',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'HTML ID Attribute',
            value: '',
            message: 'Override the ID attribute of the element. If not specified, reverts to GUID',
        };
    },

    watch: {
        value() {
            if (this.isValidId()) {
                this.selectedElements[0].idOverrideNew = this.value;
                this.onOptionChange(this.value);
            }
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].idOverrideNew;
        },

        isValidId() {
            // Allowing empty to let content editors clear out the Id
            // In HTML5, the only illegal charactor is a space
            return this.value === '' || this.value.indexOf(' ') === -1;
        },
    },
};
</script>
